import './ButtonReset-904f2483.css';

var classes = {"ButtonReset":"prc-components-ButtonReset-9kafa"};

export { classes as default };
